export default {
  loanValue: 'Výše úvěru',
  personData: 'Údaje o Vás',
  banking: 'Bankovní výpisy',
  collateral: 'Zajištění',
  documents: 'Dokumenty',
};
